/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { Modal, message } from 'antd';

/**
 * Hook para importação de arquivos
 * Agora apenas fornece função de sucesso, pois tratamento de erros foi movido para useImportErrorHandler
 */
export const useApontamentoImport = () => {
  const showSuccessAlert = () => {
    Modal.success({
      title: 'Sucesso',
      content: <p>Planilha importada com sucesso!</p>,
    });

    message.info(
      <>
        Os valores de <b>Total de Rendimentos, Total Débitos e Líquido</b> não serão considerados na importação.
      </>,
      10
    );
  };

  return {
    exibirAlertaSucesso: showSuccessAlert,
  };
};
